import { color } from '@metro-ui/tokens/js';
export var variants = {
    success: {
        variantColor: color.success,
        textColor: color.inverted,
    },
    info: {
        variantColor: color.interaction,
        textColor: color.inverted,
    },
    warning: {
        variantColor: color.attention,
        textColor: color.palette.grey.tint[20],
    },
    error: {
        variantColor: color.danger,
        textColor: color.inverted,
    },
    offline: {
        variantColor: color.palette.grey.tint[20],
        textColor: color.inverted,
    },
};
//# sourceMappingURL=utils.js.map